export const isBFSale = (): boolean => {
  return false;
};
